import { createModule, constants } from "./redux-acron";
import api from "services/api";
import { handlerWrapper, handlerEffects } from "../utils";
import initialState from "../utils/initialState";

export default createModule({
  name: "cocreation",
  modelName: "cocreation",

  state: initialState.cocreation,

  // ------

  handlers: {
    getCocreationDashboard: (
      state,
      { payload, status = constants.PENDING_STATUS }
    ) => {
      return handlerWrapper("dashboard", state, status, payload);
    }
  },

  effects: {
    getCocreationDashboard: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.cocreation.getCocreationDashboard,
          payload,
          actions.getCocreationDashboard
        );
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/CocreationModule.js